import React from 'react';
import { LeftPanelProps } from './LeftPanelProps';

const CompletionLeftPanel: React.FC<LeftPanelProps> = (data) => {
  return (
    <div className="h-100 w-100 py-6 px-5 d-flex justify-content-center align-items-center bg-primary">
      <img src="/images/seller-completion-check.svg" alt="completion checkmark" />
    </div>
  );
};

export default CompletionLeftPanel;
